/** When your routing table is too long, you can split it into small modules**/


export default [{
  path: '/delete-course-request',
  name: 'DeleteCourseRequest',
  component: () => import('@/views/delete-course/Request'),
},
{
  path: '/delete-course-history',
  name: 'DeleteCourseHistory',
  component: () => import('@/views/delete-course/Index'),
}]

